import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import api, { operation } from '../services/axios'
import { StoreState } from '../store'
type CredenciadorasType = {
    [key: string]: string
}
export const useCredenciadoras = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [todasCredenciadoras, setTodasCredenciadoras] = useState(
        {} as CredenciadorasType
    )
    const [suasCredenciadoras, setSuasCredenciadoras] = useState(
        {} as CredenciadorasType
    )
    const [ispb, setIspb] = useState({} as CredenciadorasType)

    const getTodasCredenciadoras = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                const { data } = await api.get(
                    '/backoffice/obter/credenciadoras'
                )
                setTodasCredenciadoras(data.todasCredenciadoras)
            } catch (error) {}
        })
    }, [])

    useEffect(() => {
        getTodasCredenciadoras()
    }, [getTodasCredenciadoras])

    const getSuasCredenciadoras = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                const { data } = await api.get(
                    `/obter/credenciadoras/${cnpj_cpf}`
                )
                setSuasCredenciadoras(
                    data.suasCredenciadorasComUnidadesRecebiveis
                )
            } catch (error) {}
        })
    }, [cnpj_cpf])

    useEffect(() => {
        getSuasCredenciadoras()
    }, [getSuasCredenciadoras])

    function nomeCredenciadora(cnpj: keyof typeof todasCredenciadoras) {
        if (!todasCredenciadoras[cnpj]) {
            return ''
        }

        return todasCredenciadoras[cnpj]
    }

    return {
        todasCredenciadoras,
        suasCredenciadoras,
        nomeCredenciadora,
    }
}
